var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 378,
    viewBox: "0 0 378 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4769_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.136 80.073C222.91 69.111 252 45.4072 252 12.6V0H126V12.6C126 45.4072 155.09 69.111 171.864 80.073C87.381 93.051 15.75 198.923 15.75 283.5C15.75 335.617 58.1333 378 110.25 378H267.75C319.867 378 362.25 335.617 362.25 283.5C362.25 198.923 290.619 93.051 206.136 80.073Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4769_163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 378,
    height: 378,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSac);
export default __webpack_public_path__ + "static/media/sac.6aa3b0fd019874b25e4242dd61c8d336.svg";
export { ForwardRef as ReactComponent };